export default "__VITE_ASSET__jkjtkaEK__"